import { signal } from 'services/SignalsService'

export default class ExplosionReelsEntity extends PIXI.Container {
  constructor() {
    super()
    this.reels = []
    signal.on('ExplosionReelsEntity:START', () => {

      this.start()
      signal.once('ACTION:REEL-SPIN', () => this.stop())
    })
    signal.on('ExplosionReelsEntity:REFRESH', this.refresh.bind(this))
  }

  refresh() {
    this.reels.forEach((reel) => reel.refresh())
  }

  async start() {
    signal.dispatch('REELS-START', 'explosion')
    await Promise.all(this.reels.map((r) => r.start()))
  }

  async stop() {
    await Promise.all(this.reels.map((r) => r.stop()))
    signal.dispatch('REELS-STOP')
  }

  register = (type, object) => {
    if (type == 'ExplosionReel') {
      this.reels.push(object)
    }
  }
}
